<script>
import InputText from '@components/form/InputText'
import InputMultiSelect from '@components/form/InputMultiSelect'

export default {
  name: 'modalAddress',
  components: { InputText, InputMultiSelect },
  props: {
    idmodal: {
      type: String,
      required: true,
    },
    value: {
      type: [String, Number],
      required: false,
      default: null,
    },
  },
  mounted() {
  },
  data() {
    return {
      modal: false,
      data: {
        value_: null,
        selectedRoute: {},
        selectedZone: {},
        selectedZone2: {},
        number: '',
        lyrics: {},
        sign: '#',
        sign2: '-',
        number2: '',
        lyrics2: {},
        number3: '',
        observations: '',
        finalAddress: '',
      },
      options: [
        { value: 'AUT', text: 'Autopista' },
        { value: 'AV', text: 'Avenida' },
        { value: 'BLV', text: 'Bulevar' },
        { value: 'CIR', text: 'Circular' },
        { value: 'CL', text: 'Calle' },
        { value: 'CR', text: 'Carrera' },
        { value: 'CRT', text: 'Carretera' },
        { value: 'CRV', text: 'Circunvalar' },
        { value: 'CRG', text: 'Corregimiento' },
        { value: 'DG', text: 'Diagonal' },
        { value: 'KM', text: 'Kilómetro' },
        { value: 'TV', text: 'Transversal' },
        { value: 'TC', text: 'Troncal' },
        { value: 'VT', text: 'Variante' },
        { value: 'VRD', text: 'Vereda' },
        { value: 'VI', text: 'Vía' },
      ],
      optionsLetter: [
        { value: 'A', text: 'A' },
        { value: 'AA', text: 'AA' },
        { value: 'AB', text: 'AB' },
        { value: 'AC', text: 'AC' },
        { value: 'AD', text: 'AD' },
        { value: 'AE', text: 'AE' },
        { value: 'AF', text: 'AF' },
        { value: 'AG', text: 'AG' },
        { value: 'AH', text: 'AH' },
        { value: 'B', text: 'B' },
        { value: 'BB', text: 'BB' },
        { value: 'BA', text: 'BA' },
        { value: 'BC', text: 'BC' },
        { value: 'BD', text: 'BD' },
        { value: 'BE', text: 'BE' },
        { value: 'BF', text: 'BF' },
        { value: 'BG', text: 'BG' },
        { value: 'BH', text: 'BH' },
        { value: 'C', text: 'C' },
        { value: 'CC', text: 'CC' },
        { value: 'CA', text: 'CA' },
        { value: 'CB', text: 'CB' },
        { value: 'CD', text: 'CD' },
        { value: 'CE', text: 'CE' },
        { value: 'CF', text: 'CF' },
        { value: 'CG', text: 'CG' },
        { value: 'CH', text: 'CH' },
        { value: 'D', text: 'D' },
        { value: 'DD', text: 'DD' },
        { value: 'DA', text: 'DA' },
        { value: 'DB', text: 'DB' },
        { value: 'DC', text: 'DC' },
        { value: 'DE', text: 'DE' },
        { value: 'DF', text: 'DF' },
        { value: 'DG', text: 'DG' },
        { value: 'DH', text: 'DH' },
        { value: 'E', text: 'E' },
        { value: 'EE', text: 'EE' },
        { value: 'EA', text: 'EA' },
        { value: 'EB', text: 'EB' },
        { value: 'EC', text: 'EC' },
        { value: 'ED', text: 'ED' },
        { value: 'EF', text: 'EF' },
        { value: 'EG', text: 'EG' },
        { value: 'EH', text: 'EH' },
        { value: 'F', text: 'F' },
        { value: 'FF', text: 'FF' },
        { value: 'FA', text: 'FA' },
        { value: 'FB', text: 'FB' },
        { value: 'FC', text: 'FC' },
        { value: 'FD', text: 'FD' },
        { value: 'FE', text: 'FE' },
        { value: 'FG', text: 'FG' },
        { value: 'FH', text: 'FH' },
        { value: 'G', text: 'G' },
        { value: 'GG', text: 'GG' },
        { value: 'GA', text: 'GA' },
        { value: 'GB', text: 'GB' },
        { value: 'GC', text: 'GC' },
        { value: 'GD', text: 'GD' },
        { value: 'GE', text: 'GE' },
        { value: 'GF', text: 'GF' },
        { value: 'GH', text: 'GH' },
        { value: 'H', text: 'H' },
        { value: 'HH', text: 'HH' },
        { value: 'HA', text: 'HA' },
        { value: 'HB', text: 'HB' },
        { value: 'HC', text: 'HC' },
        { value: 'HD', text: 'HD' },
        { value: 'HE', text: 'HE' },
        { value: 'HF', text: 'HF' },
        { value: 'HG', text: 'HG' },
      ],
      optionsZone: [
        { value: 'ESTE', text: 'Este' },
        { value: 'NORTE', text: 'Norte' },
        { value: 'OESTE', text: 'Oeste' },
        { value: 'SUR', text: 'Sur' },
        { value: 'BIS', text: 'Bis' },
      ],
    }
  },
  methods: {
    closeModal() {
      this.modal = false
    },
    cancel() {
      this._value = ''
      this.closeModal()
    },
  },
  watch: {
    data: {
      deep: true,
      handler(newValue, oldValue) {
        this._value = this.getFinalAddress
      },
    },
  },
  computed: {
    getFinalAddress() {
      return (
        (this.data.selectedRoute !== null &&
        Object.keys(this.data.selectedRoute).length > 0
          ? this.data.selectedRoute.value
          : '') +
        ' ' +
        (this.data.number || '') +
        '' +
        (Object.keys(this.data.lyrics).length > 0
          ? this.data.lyrics.value
          : '') +
        ' ' +
        (Object.keys(this.data.selectedZone).length > 0
          ? this.data.selectedZone.value
          : '') +
        ' ' +
        (Object.keys(this.data.selectedRoute).length > 0 && this.data.number
          ? this.data.sign
          : '') +
        ' ' +
        (this.data.number2 || '') +
        '' +
        (Object.keys(this.data.lyrics2).length > 0
          ? this.data.lyrics2.value
          : '') +
        ' ' +
        (Object.keys(this.data.selectedZone2).length > 0
          ? this.data.selectedZone2.value
          : '') +
        ' ' +
        (Object.keys(this.data.selectedRoute).length > 0 && this.data.number3
          ? this.data.sign2
          : '') +
        ' ' +
        (this.data.number3 || '') +
        ' ' +
        (this.data.observations || '')
      ).replace(/  +/g, ' ')
    },
    _value: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('update:value', value)
        this.$emit('input', value)
      },
    },
  },
}
</script>

<template>
  <ValidationObserver
    id="typeFormAddress"
    ref="observerAddress"
    v-slot="{ handleSubmit }"
  >
    <b-modal
      v-model="modal"
      :id="`address-modal${idmodal}`"
      size="lg"
      title="Ingrese la dirección"
    >
      <b-row>
        <b-col cols="7" md="3">
          <InputMultiSelect
            id="routeType"
            name="routeType"
            label="Tipo de Vía"
            :options="options"
            trackBy="value"
            :custom-label="(t) => t.text"
            selectLabel="✚"
            selectedLabel="✓"
            deselectLabel="✖"
            :multiple="false"
            validate="required"
            placeholder="Seleccione"
            :value.sync="data.selectedRoute"
          />
        </b-col>
        <b-col cols="5" md="3">
          <inputText
            id="number"
            name="number"
            label="Número"
            type="number"
            :validate="{
              minmax: [0, 1999],
              required:
                Object.keys(data.selectedRoute).length > 0
                  ? !['CRT', 'VRD', 'CRG', 'VT', 'VI'].includes(
                      data.selectedRoute.value
                    )
                    ? true
                    : false
                  : false,
            }"
            validationMode="aggressive"
            :value.sync="data.number"
            placeholder="Número"
          />
        </b-col>
        <b-col cols="5" md="3">
          <InputMultiSelect
            id="lyrics"
            name="lyrics"
            label="Letra"
            :options="optionsLetter"
            trackBy="value"
            :custom-label="(t) => t.text"
            selectLabel="✚"
            selectedLabel="✓"
            deselectLabel="✖"
            :multiple="false"
            placeholder="Seleccione"
            :value.sync="data.lyrics"
          />
        </b-col>
        <b-col cols="7" md="3">
          <InputMultiSelect
            id="selectedZone"
            name="selectedZone"
            label="Zona"
            :options="optionsZone"
            trackBy="value"
            :custom-label="(t) => t.text"
            selectLabel="✚"
            selectedLabel="✓"
            deselectLabel="✖"
            :multiple="false"
            placeholder="Seleccione"
            :value.sync="data.selectedZone"
          />
        </b-col>
      </b-row>
      <b-row class="mt-1 mt-md-2">
        <b-col cols="5" md="3" class="sign-hash">
          <inputText
            id="number2"
            name="number2"
            label="Número"
            type="number"
            :validate="{
              minmax: [0, 1999],
              required:
                Object.keys(data.selectedRoute).length > 0
                  ? !['CRT', 'VRD', 'CRG', 'VT', 'VI'].includes(
                      data.selectedRoute.value
                    )
                    ? true
                    : false
                  : false,
            }"
            validationMode="aggressive"
            :value.sync="data.number2"
            placeholder="Número"
          />
        </b-col>
        <b-col cols="7" md="3">
          <InputMultiSelect
            id="lyrics2"
            name="lyrics2"
            label="Letra"
            :options="optionsLetter"
            trackBy="value"
            :custom-label="(t) => t.text"
            selectLabel="✚"
            selectedLabel="✓"
            deselectLabel="✖"
            :multiple="false"
            placeholder="Seleccione"
            :value.sync="data.lyrics2"
          />
        </b-col>
        <b-col cols="6" md="3">
          <InputMultiSelect
            id="selectedZone2"
            name="selectedZone2"
            label="Zona"
            :options="optionsZone"
            trackBy="value"
            :custom-label="(t) => t.text"
            selectLabel="✚"
            selectedLabel="✓"
            deselectLabel="✖"
            :multiple="false"
            placeholder="Seleccione"
            :value.sync="data.selectedZone2"
          />
        </b-col>
        <b-col cols="6" md="3" class="sign-dash">
          <inputText
            id="number3"
            name="number3"
            label="Número"
            type="number"
            :validate="{
              minmax: [0, 1999],
              required:
                Object.keys(data.selectedRoute).length > 0
                  ? !['CRT', 'VRD', 'CRG', 'VT', 'VI'].includes(
                      data.selectedRoute.value
                    )
                    ? true
                    : false
                  : false,
            }"
            validationMode="aggressive"
            :value.sync="data.number3"
            placeholder="Número"
          />
        </b-col>
      </b-row>
      <b-row class="mt-1 mt-md-2">
        <b-col cols="12">
          <label>
            <strong> Observaciones </strong>
          </label>
          <b-form-input
            v-model="data.observations"
            placeholder="Apto 105"
          ></b-form-input>
        </b-col>
      </b-row>
      <b-row class="mt-1 mt-md-2">
        <b-col cols="12">
          <label>
            <strong> Dirección ingresada </strong>
          </label>
          <b-form-input :value="getFinalAddress" plaintext></b-form-input>
        </b-col>
      </b-row>
      <template #modal-footer="{}">
        <b-button @click="cancel()"> Cancelar </b-button>
        <b-button variant="primary" @click="handleSubmit(closeModal)">
          Aceptar
        </b-button>
      </template>
    </b-modal>
  </ValidationObserver>
</template>
<style lang="scss">
#address-modal {
  .form-group {
    margin-bottom: 0.5rem;
  }
}
.sign-dash {
  legend {
    padding-left: 12px;
  }
  .form-control {
    width: calc(100% - 18px);
    display: inline-block;
  }
}
.sign-hash {
  legend {
    padding-left: 12px;
  }
  .form-control {
    width: calc(100% - 18px);
    display: inline-block;
  }
}
</style>